// extracted by css-extract-rspack-plugin
export default {"TargetTrigger":"ClickMappings-module__TargetTrigger___xKNtM"};